import BossModel from "@/models/BossModel";
import moment from "moment";

export default class ExchangeRate extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'exchange-rate';

    /**
     *
     * @type {string}
     */
    static entity = 'exchangeRates';

    static fields() {
		return {
			id: this.attr(null),
			currency_id: this.attr(null),
			exchange_rate: this.attr(null),
			user_id: this.attr(null),
			start: this.attr(null),
			end: this.attr(null),
			created_at: this.attr(null),
			updated_at: this.attr(null),
		}
	}

    /**
     *
     * @param currencyId
     * @param date
     * @returns {Promise<unknown>|PromiseLike<any>|Promise<any>|*}
     */
    static findOrLoadByDateAndCurrency(currencyId, date = null) {
        if (date === null) {
            date = moment().format('YYYY-MM-DD');
        }

        if (!this.existsByCurrencyAndDate(currencyId, date)) {
            return this.loadByDateAndCurrency(currencyId, date).then(() => {
                return this.all().filter(exchangeRate =>
                    parseInt(exchangeRate.currency_id) === parseInt(currencyId) &&
                    exchangeRate.start <= date &&
                    exchangeRate.end > date
                );
            });
        }

        return new Promise((resolve) => {
            resolve(this.all().filter(exchangeRate =>
                parseInt(exchangeRate.currency_id) === parseInt(currencyId) &&
                exchangeRate.start <= date &&
                exchangeRate.end > date
            ));
        });
    }

    /**
     *
     * @param currencyId
     * @param date
     * @returns {*}
     */
    static existsByCurrencyAndDate(currencyId, date) {
        return this.all().some(exchangeRate =>
            parseInt(exchangeRate.currency_id) === parseInt(currencyId) &&
            exchangeRate.start <= date &&
            exchangeRate.end > date
        );
    }

    /**
     *
     * @param currencyId
     * @param date
     * @returns {*}
     */
    static loadByDateAndCurrency(currencyId, date) {
        return this.api()
            .limit(0)
            .where('currency_id', currencyId)
            .where('onDateString', date)
            .get(true);
    }
}
